<template>
  <div class="dropzone" ref="uploader"></div>
</template>
<script>
  import 'dropzone/dist/dropzone.css'
  import Dropzone from 'dropzone'
  Dropzone.autoDiscover = false
  export default {
    props: ['maxFiles', 'acceptedFiles', 'maxFileSize', 'url'],
    data () {
      return {
        uploader: undefined
      }
    },
    mounted () {
      const me = this
      const maxFiles = 1
      const maxFileSize = 10
      me.uploader = new Dropzone(me.$refs.uploader, {
        acceptedFiles: 'image/jpeg,image/png,image/gif',
        maxFiles: maxFiles,
        maxFilesize: maxFileSize,
        dictDefaultMessage: 'Arrastre el archivo aquí o haga click para seleccionar',
        url: this.url,
        init () {
          this.on('success', (file, responseText) => {
            // console.log('file', file, responseText)
            me.$emit('upload-correct', responseText)
          })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Uploader.vue?776e7aca